import React from 'react';

interface UnternehmensTableProps<T>
{
  columns: string[];
  data: T[];
  renderRow: (data: T) => JSX.Element;
}

export default function <T extends object> (props: UnternehmensTableProps<T>)
{
  const { columns, data, renderRow } = props;

  return (
      <table className="profileTable">
        <thead>
        <tr>
          {columns.map((column) => <th key={column}>{column}</th>)}
        </tr>
        </thead>

        <tbody>
        {data.map(renderRow)}
        </tbody>
      </table>
  );
}
